import { store } from "@/store/store";
import { solicitudes_eventos_audit } from "@/shared/dtos/solicitudes_eventos_audit";
import { VuexModule, Mutation, getModule, Module, Action } from "vuex-module-decorators";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";

@Module({ namespaced: true, name: "solicitudesEventosAuditModule", store, dynamic: true })
class solicitudesEventosAuditModule extends VuexModule {
  public rows: solicitudes_eventos_audit[] = [];
  public row: solicitudes_eventos_audit = new solicitudes_eventos_audit();

  @Action({ commit: "onGetRows" })
  public async getRows() {
    return await ssmHttpService.get(API.solicitudes_eventos_audit);
  }

  @Action({ commit: "onGetRow" })
  public async getRow(id: any) {
    return await ssmHttpService.get(API.solicitudes_eventos_audit + "/" + id);
  }

  @Action
  public async guardar(item: solicitudes_eventos_audit) {
    return await ssmHttpService.post(API.solicitudes_eventos_audit, item.toJson(["created_at"]));
  }

  @Action
  public async modificar(item: solicitudes_eventos_audit) {
    return await ssmHttpService.put(API.solicitudes_eventos_audit + "/" + item.id, item.toJson(["created_at"]));
  }

  @Action
  public async eliminar(item: solicitudes_eventos_audit) {
    return await ssmHttpService.delete(API.solicitudes_eventos_audit + "/" + item.id, null, false);
  }

  @Mutation
  public onGetRows(res: solicitudes_eventos_audit[]) {
    this.rows = res ? res.map((x) => new solicitudes_eventos_audit(x)) : [];
  }

  @Mutation
  public onGetRow(res: solicitudes_eventos_audit) {
    this.row = new solicitudes_eventos_audit(res);
  }
}

export default getModule(solicitudesEventosAuditModule);
